'use strict';

module.exports = require('./json-rules-engine');